import React, { Component, Fragment } from 'react'
import Breadcrumb from "../../common/breadcrumb"
import Datatable from '../../common/datatable'
import { AvField, AvForm } from 'availity-reactstrap-validation';
import { Button, Label} from 'reactstrap';
import {Link} from 'react-router-dom'
import Dropzone from 'react-dropzone-uploader';
import queryString from "query-string";
import { getObject, updateObject, listItems } from "../../api";
import { FlowDataEntry } from '../../common/flowDataEntry'


export class MediaEdit extends Component {
    constructor(props) {
        super(props)
        const value=queryString.parse(this.props.location.search);

        this.state = {
            loading: true,
            pid: value.pid,
            data: {},
            file: '',
            src: null,
            srcMeta: null
        }
    }


    baseUrlUpdated = () => {
        var that=this;
        const value = document.getElementById("baseUrl").value;
        var img = new Image();
        img.addEventListener("load", function(){
            that.setState({src: value, srcMeta: {width: this.naturalWidth, height: this.naturalHeight}} );
        });
        img.src = value;
    }

    handleDropChangeStatus = (file, status) => {
        if (status === 'done') {
            file.remove();

            var that = this;
            var reader  = new FileReader();
            
            reader.addEventListener("load", function () {

                that.setState(prevState => ({
                    data: {
                      ...prevState.data, 
                      baseUrl: "",
                      filename: file.file.name,
                      contentType: file.file.type,
                    },
                    file: file.file,
                    src: reader.result,
                    srcMeta: file.meta
                }))
            }, false);

            if (file.file) {
                reader.readAsDataURL(file.file);
            } 
        }
    }

    onValidSubmit = (event, values) => {
        const {file, data } = this.state;

        const formData = new FormData(document.getElementById('mainForm'));
        formData.append('filename', data.filename);
        formData.append('contentType', data.contentType);
        formData.append('fileId', data._id);
        if (file instanceof Blob ) {
            formData.append('image', file, file.name);   
        } 

        this.onSaveMedia(formData);
    };
    
    onInvalidSubmit = (event, errors, values) => {
        this.setState({errors, values});
    };

    onSaveMedia = (values) => {
        updateObject('media',  values, this.state.pid).then(d2 => {
            if (d2 && d2.error) {
                console.log(d2.error);
            } else {
                this.loadMedia();
            }
        });
    };

    loadMedia = () => {
        var that=this;
        this.setState({ loading: true});
        if (this.state.pid) {
            getObject('media',this.state.pid).then(d2 => {
                if (d2 && d2.error) {
                    console.log(d2.error);
                } else {
                    if (d2.baseUrl) {
                        var img = new Image();
                        img.addEventListener("load", function(){
                            that.setState({data: d2, src: d2.baseUrl, srcMeta: {width: this.naturalWidth, height: this.naturalHeight}, loading: false} );
                        });
                        img.src = d2.baseUrl;    
                    } 
                    else {
                        this.setState({data: d2, src: d2.baseUrl, srcMeta: null, loading: false} );
                    }                                  
                }
            });
        } else this.setState({ loading: false});
    };

    componentDidMount() {
        this.loadMedia();        
    }

    render() {
        const defaultValues = this.state.data;
        var newMedia = !(defaultValues.baseUrl && defaultValues.baseUrl.startsWith("https://licontent.nyc3.digitaloceanspaces.com/media/"))
        const revisions = this.state.data.revisions && this.state.data.revisions.length && this.state.data.revisions[0] ? this.state.data.revisions : [];
        if (this.state.loading) { return null; }
        else {
            setTimeout(function() {
                document.querySelector(".loader-wrapper").style = "display: none";
            }, 100);       
        return (
            <Fragment>
                <Breadcrumb title="Edit Media" parents={[{name: "Media List", url: "/admin/media/list"}]} />

                <AvForm id="mainForm" className="needs-validation" onValidSubmit={this.onValidSubmit} onInvalidSubmit={this.onInvalidSubmit} model={defaultValues}>
                    <FlowDataEntry > 
                        <Fragment>
                            <AvField label="Title" grid={{xs: 10}} name="title" id="title" type="text" />
                            <AvField label="Caption" grid={{xs: 10}} name="altText" id="altText" type="text" />
                            <AvField label="Credit" grid={{xs: 10}} name="creditText" id="creditText" type="text" />
                            <AvField label="Tags" grid={{xs: 10}} name="tags" id="tags" type="text" value={listItems(this.state.data.tags)}/>     
                            <AvField label="wpId" grid={{xs: 10}} name="wpId" id="wpId" type="text" />
                        </Fragment>  

                        {newMedia ?
                        <Fragment>
                            <div className="row">
                                <div className="col-sm-2">  
                                    <Label className="col-2m-2">Add Media</Label>
                                </div>
                                <div className="col-sm-10" style={{paddingBottom: '15px'}}>                              
                                    <div className="dropzone col-sm-12">
                                        <Dropzone
                                            onChangeStatus={this.handleDropChangeStatus}
                                            maxFiles={1}
                                            multiple={false}
                                            canCancel={false}

                                            inputContent="Drop files, or click to select"
                                            accept="image/*,audio/*,video/*"                                              
                                        />  
                                    </div>                                         
                                </div> 
                            </div>  
                            <AvField label="Web Address" grid={{xs: 10}} name="baseUrl" id="baseUrl" type="text" value={defaultValues.baseUrl}  onBlur={this.baseUrlUpdated}/>
                            {this.state.srcMeta &&
                                <a href={this.state.src} target="_blank" rel="noopener noreferrer"><img src={this.state.src}  className="img-fluid" style={{height:144, width:144 * (this.state.srcMeta.width / this.state.srcMeta.height)}} alt="" /></a>
                            }
                        </Fragment>
                        :
                        <Fragment>
                            <div className="row">
                                <div className="col-sm-4">  
                                    {this.state.srcMeta &&
                                        <a href={this.state.src} target="_blank" rel="noopener noreferrer"><img src={this.state.src}  className="img-fluid" style={{height:144, width:144 * (this.state.srcMeta.width / this.state.srcMeta.height)}} alt="" /></a>
                                    }
                                </div>
                                <div className="col-sm-8">  
                                    <div className="row">
                                        <div className="col-sm-2">Commands
                                        </div>                                         
                                        <div className="col-sm-10">  
                                            <Link to={`/admin/media/revise?pid=${defaultValues._id}`}>
                                                <Button className="btn btn-primary" style={{marginBottom: '15px'}}>Make Revision</Button>
                                            </Link>
                                        </div>
                                    </div>
                                    <AvField label="Url" readOnly grid={{xs: 10}} name="baseUrl" id="baseUrl" type="text" />    
                                    <AvField label="File Name" readOnly grid={{xs: 10}} name="filename" id="filename" type="text" />    
                                    <AvField label="Content Type" readOnly grid={{xs: 10}} name="contentType" id="contentType" type="text" />  

                                </div>
                            </div>                                        
                        </Fragment>        
                        }                                 
                  

                        <div className="card">
                            <div className="card-header">
                                <h5>Revisions</h5>
                                <div className="card-body">
                                    <div className="row">
                                        <div className="col-sm-12">
                                            <div id="batchDelete" className="category-table media-table coupon-list-delete">
                                                <Datatable
                                                    multiSelectOption={false}
                                                    myData={revisions}
                                                    columns={['baseUrl', 'contentType', 'format']}
                                                    imageUrlField='baseUrl'
                                                    showCopy={'baseUrl'}
                                                    pageSize={10}
                                                    pagination={true}
                                                    onItemView={true}
                                                    class="-striped -highlight"
                                                />
                                            </div>                                
                                        </div>
                                    </div>
                                </div>   
                            </div>                        
                        </div>           

                    </FlowDataEntry>  
                </AvForm>  
 
                
                                                        
            </Fragment>
        )
    }
}
}

export default MediaEdit


